import React from 'react';
import { CubeIcon } from '@heroicons/react/20/solid';
import { TableCell, Checkbox } from '@material-ui/core';

import { NavigationCell } from '../NavigationCell';
import { removeCid } from '../../../utils';

import styles from './ItemCell.module.scss';

const Cell = ({ row, children = null, className = '' }) => {
	return (
		<NavigationCell id={row.labelId} className={className} barcode={row.barcode}>
			<div className={styles.itemCell}>
				{row.images && row.images.length ? (
					<img className={styles.image} src={row.images?.[0]} alt={row.barcode.slice(0, 4) + '...'} />
				) : (
					<div className={styles.image}>
						<CubeIcon />
					</div>
				)}
				<div className={styles.itemDetails}>
					{row.title && <p className={styles.title}>{row.title}</p>}
					<p className={styles.barcode}>{removeCid(row.barcode)}</p>
					{children}
				</div>
			</div>
		</NavigationCell>
	);
};

const Item = ({ row, setSelectedBarcodes }) => {
	const handleSelect = (barcode) => {
		setSelectedBarcodes((existingValues) => [...existingValues, barcode]);
	};

	const handleDeselect = (barcode) => {
		setSelectedBarcodes((existingValues) => existingValues.filter((b) => b !== barcode));
	};

	return (
		<>
			<TableCell className={styles.checkboxCell}>
				<Checkbox
					color="primary"
					className={styles.checkbox}
					checked={row.isSelected}
					onClick={(e) => {
						e.stopPropagation();
						row.isSelected ? handleDeselect(row.barcode) : handleSelect(row.barcode);
					}}
					inputProps={{
						'aria-labelledby': row.labelId
					}}
				/>
			</TableCell>
			<Cell row={row} className={styles.titleCell} />
		</>
	);
};

export { Item, Cell as ItemCell };
